import styled from "styled-components";
import HistoryItems from "./items";

export default styled(HistoryItems)`
  .title-history {
    max-width: 60rem;
    margin: 0 auto;
    font-size: 3rem;
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .history-items {
    margin: 2rem;
  }
`;
